export const MIN_CEIL_SIZE_TO_ADAPTIVE = 50
export const MAX_CEIL_SIZE = 80
export const ADAPTIVE_GAP = 40
